export const formatCPF = (cpf: string, isViewFull?: boolean): string => {
  const cleanedCPF = cpf.replace(/\D/g, '');

  if (isViewFull) {
    return cleanedCPF
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  }

  //senao retorna mascara que só ve os ultimos 2 digitos
  // ***.***.***-**
  const lastTwoDigits = cleanedCPF.slice(-2);
  return `***.***.***-${lastTwoDigits}`;
};


export const formatVisibleCPF = (cpf: string): string => {
  const cleanedCpf = cpf.replace(/\D/g, '');
  return cleanedCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};
